import BusinessLicenseInput from './business-license-input.vue'
export type { BusinessLicenseInputProps } from './props'
export default BusinessLicenseInput